import { createIcon } from '@chakra-ui/icons';

export const EmailIcon = createIcon({
  displayName: 'EmailIcon',
  viewBox: '0 0 32 32',
  path: [
    <g key="1" clipPath="url(#shareEmail)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 7.99969C32 6.78765 31.5185 5.62525 30.6615 4.76821C29.8044 3.91117 28.642 3.42969 27.43 3.42969H4.57C3.35796 3.42969 2.19556 3.91117 1.33852 4.76821C0.481481 5.62525 0 6.78765 0 7.99969L0 23.9997C0 25.2117 0.481481 26.3741 1.33852 27.2312C2.19556 28.0882 3.35796 28.5697 4.57 28.5697H27.43C28.642 28.5697 29.8044 28.0882 30.6615 27.2312C31.5185 26.3741 32 25.2117 32 23.9997V7.99969Z"
        fill="#FDCB6E"
      />
      <path
        d="M15.9999 15.7205C14.5911 15.7262 13.2077 15.3457 11.9999 14.6205L4.82994 10.3205C4.63517 10.2023 4.49524 10.0117 4.44087 9.79047C4.3865 9.56924 4.42213 9.33547 4.53994 9.14049C4.65811 8.94572 4.84873 8.80579 5.06996 8.75142C5.29119 8.69705 5.52495 8.73268 5.71994 8.85049L12.8799 13.1505C13.8131 13.7111 14.8813 14.0073 15.9699 14.0073C17.0586 14.0073 18.1267 13.7111 19.0599 13.1505L26.2299 8.85049C26.4249 8.73268 26.6587 8.69705 26.8799 8.75142C27.1012 8.80579 27.2918 8.94572 27.4099 9.14049C27.5278 9.33547 27.5634 9.56924 27.509 9.79047C27.4546 10.0117 27.3147 10.2023 27.1199 10.3205L19.9999 14.6205C18.7921 15.3457 17.4087 15.7262 15.9999 15.7205Z"
        fill="#F39C12"
      />
    </g>,
    <defs key="2">
      <clipPath id="shareEmail">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>,
  ],
});
